module.exports = __webpack_public_path__ + "img/bindEmail.5bc2760c.png";